import { render, staticRenderFns } from "./SanifairFilter.vue?vue&type=template&id=f3727cf8"
import script from "./SanifairFilter.vue?vue&type=script&lang=ts"
export * from "./SanifairFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports